import lightLoadingDots from '@rhg/../public/_n/animations/loading_dots_light.json';

export default lightLoadingDots;
